<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      width="300"
    >
      <v-list
        nav
        expand
        dense
        flat
        class="main-menu"
      >
        <v-list-item
          :to="{name: 'dashboard'}"
          class="menu-height"
        >
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="text-body-2 font-weight-regular">
            {{ 'v2.fm.menu.dashboard'|trans }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'diagnostics'}">
          <v-list-item-icon>
            <v-icon>mdi-chart-timeline-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="text-body-2 font-weight-regular">
            {{ 'v2.fm.menu.monitor'|trans }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'location'}">
          <v-list-item-icon>
            <v-icon>mdi-map</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="text-body-2 font-weight-regular">
            {{ 'v2.fm.menu.devices-localization'|trans }}
          </v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-group
          prepend-icon="mdi-bell"
          no-action
          :value="true"
        >
          <template #activator>
            <v-list-item-title class="text-body-2 font-weight-regular">
              {{ 'v2.fm.menu.alerts'|trans }}
            </v-list-item-title>
          </template>
          <v-list-item :to="{name: 'alerts-list'}">
            <v-list-item-title class="text-body-2 font-weight-regular">
              {{ 'v2.fm.menu.alert-list'|trans }}
            </v-list-item-title>
            <alert />
          </v-list-item>
          <v-list-item :to="{name: 'alert-rules'}">
            <v-list-item-title class="text-body-2 font-weight-regular">
              {{ 'v2.fm.menu.alert-rules'|trans }}
            </v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider />
        <v-list-group
          prepend-icon="mdi-factory"
          no-action
          :value="true"
          class="nav-section-manage"
        >
          <template #activator>
            <v-list-item-title class="text-body-2 font-weight-regular">
              {{ 'v2.fm.menu.production'|trans }}
            </v-list-item-title>
          </template>
          <v-list-item :to="{name: 'production'}">
            <v-list-item-title class="text-body-2 font-weight-regular">
              {{ 'v2.fm.menu.work'|trans }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item :to="{name: 'reports'}">
            <v-list-item-title class="text-body-2 font-weight-regular">
              {{ 'v2.fm.menu.reports-cyclic'|trans }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item :to="{name: 'reports-list'}">
            <v-list-item-title class="text-body-2 font-weight-regular">
              {{ 'v2.fm.menu.reports-list'|trans }}
            </v-list-item-title>
          </v-list-item>
        </v-list-group>
        <template v-if="hasBrainAccess">
          <v-divider />
          <v-list-item :to="{name: 'brain-reports'}">
            <v-list-item-icon>
              <v-icon>mdi-toolbox</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-body-2 font-weight-regular">
              {{ 'v2.fm.menu.brain'|trans }}
            </v-list-item-title>
          </v-list-item>
        </template>
        <v-divider />
        <v-list-group
          prepend-icon="mdi-cog"
          no-action
          :value="true"
          class="nav-section-manage"
        >
          <template #activator>
            <v-list-item-title class="text-body-2 font-weight-regular">
              {{ 'v2.fm.menu.manage'|trans }}
            </v-list-item-title>
          </template>
          <v-list-item :to="{name: 'devices'}">
            <v-list-item-title class="text-body-2 font-weight-regular">
              {{ 'v2.fm.menu.devices'|trans }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item :to="{name: 'device-groups'}">
            <v-list-item-title class="text-body-2 font-weight-regular">
              {{ 'v2.fm.menu.device-groups'|trans }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item :to="{name: 'device-operators'}">
            <v-list-item-title class="text-body-2 font-weight-regular">
              {{ 'v2.fm.menu.device-operators'|trans }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item :to="{name: 'device-operator-groups'}">
            <v-list-item-title class="text-body-2 font-weight-regular">
              {{ 'v2.fm.menu.device-operator-groups'|trans }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item :to="{name: 'users'}">
            <v-list-item-title class="text-body-2 font-weight-regular">
              {{ 'v2.fm.menu.users'|trans }}
            </v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider />
        <v-list-item @click="openSupportDialog">
          <v-list-item-icon>
            <v-icon>mdi-email-edit</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="text-body-2 font-weight-regular">
            {{ 'v2.fm.menu.support'|trans }}
          </v-list-item-title>
        </v-list-item>
        <v-divider />
        <template v-if="user.extras.isSuperAdmin">
          <v-list-group
            prepend-icon="mdi-cog"
            no-action
            :value="true"
            class="nav-section-manage"
          >
            <template #activator>
              <v-list-item-title class="text-body-2 font-weight-regular">
                {{ 'v2.fm.menu.admin'|trans }}
              </v-list-item-title>
            </template>
            <v-list-item
              :to="{name: 'administration-devices'}"
            >
              <v-list-item-title class="text-body-2 font-weight-regular">
                {{ 'v2.fm.menu.devices'|trans }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              :to="{name: 'administration-sensors'}"
            >
              <v-list-item-title class="text-body-2 font-weight-regular">
                {{ 'v2.fm.menu.sensors'|trans }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              :to="{name: 'administration-users'}"
            >
              <v-list-item-title class="text-body-2 font-weight-regular">
                {{ 'v2.fm.menu.users'|trans }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              :to="{name: 'administration-user-groups'}"
            >
              <v-list-item-title class="text-body-2 font-weight-regular">
                {{ 'v2.fm.menu.user-groups'|trans }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              :to="{name: 'administration-subscribers'}"
            >
              <v-list-item-title class="text-body-2 font-weight-regular">
                {{ 'v2.fm.menu.subscribers'|trans }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              :to="{name: 'administration-devices-types'}"
            >
              <v-list-item-title class="text-body-2 font-weight-regular">
                {{ 'v2.fm.menu.device-types'|trans }}
              </v-list-item-title>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
      <template v-if="config.brand.name === 'rejs'">
        <div
          class="center-align mt-20 clickable"
          @click="openURL('https://www.rywal.com.pl')"
        >
          <p>{{ 'v2.fm.menu.brand-owner'|trans }}</p>
          <img
            src="@assets/images/rejs/rejs.png"
            alt="rejs"
            width="200"
          >
        </div>
      </template>
    </v-navigation-drawer>
    <support-dialog
      :show-dialog="showDialog"
      @open-support-dialog="openSupportDialog"
      @close-support-dialog="closeSupportDialog"
      @submit-support-dialog="submitSupportDialog"
    />
    <bkf-refresher
      :speed="60"
      :pause="loading"
      @refresh="getData"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SupportDialog from '@components/dialogs/support/SupportDialog';
import Alert from '@components/domains/device/indicators/Alert';
import api from '@services/api';

export default {
  components: {
    Alert,
    SupportDialog,
  },
  data() {
    return {
      loading: false,
      drawer: true,
      showDialog: false,
      alerts: {
        count: 0,
        level: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      config: 'config',
      user: 'users/current',
    }),
    hasBrainAccess() {
      return this.user?.owner?.features?.brain === true;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      api.get(
        'alarms/total',
      )
        .then(
          (response) => {
            this.alerts = response.data;
            this.loading = false;
          },
        );
    },
    toggleMenu() {
      this.drawer = !this.drawer;
    },
    openSupportDialog() {
      this.showDialog = true;
    },
    closeSupportDialog() {
      this.showDialog = false;
    },
    async submitSupportDialog(values) {
      await api.post('/support/mail', values);
    },
  },
};
</script>

<style>
.badge-safari span.v-badge__wrapper {
  height: inherit !important;
}
</style>
<style lang="stylus" src="./NavMenu.styl"></style>
